module.exports = __webpack_public_path__ + "assets/img/a02328f6bb36ef08d79fb61f53944b02.png";